
define('template!compositeView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'CompositeView: Your HTML here\n<div class="collection-region"></div>';

}
return __p
};});

